export enum PlaybackSessionEvents {
    ContentLoaded = 'playbackSessionLoad',
    Created = 'playbackSessionCreate',
    SessionStarted = 'playbackStart',
    Paused = 'playbackPause',
    SessionResumed = 'playbackResume',
    Seeked = 'playbackSeek',
    SessionEnded = 'playbackSessionEnd',
    Destroyed = 'destroy',
}
